import fetch from "@/utils/fetch";
import * as types from "./mutation_types";

// Récupérer tous les markers
const getMarkers = ({ commit }) => {
  commit(types.TOGGLE_LOADING);
  return new Promise((resolve, reject) => {
    fetch({ url: 'markers' })
      .then(({ data }) => {
        commit(types.TOGGLE_LOADING);
        commit(types.SET_ITEMS, data["data"]);
        commit(types.SET_MESSAGE, data["message"]);
        resolve(data);
      })
      .catch((e) => {
        commit(types.TOGGLE_LOADING);
        commit(types.SET_ERROR, e.message);
        reject(e);
      });
  });
};

// Créer un nouveau marker
const createMarker = ({ commit }, markerData) => {
  commit(types.TOGGLE_LOADING);
  return new Promise((resolve, reject) => {
    fetch({
      url: 'markers',
      method: 'POST',
      data: markerData
    })
      .then(({ data }) => {
        commit(types.TOGGLE_LOADING);
        commit(types.ADD_MARKER, data["data"]);
        commit(types.SET_MESSAGE, data["message"]);
        resolve(data);
      })
      .catch((e) => {
        commit(types.TOGGLE_LOADING);
        commit(types.SET_ERROR, e.message);
        reject(e);
      });
  });
};

// Mettre à jour un marker
const updateMarker = ({ commit }, { id, markerData }) => {
  commit(types.TOGGLE_LOADING);
  return new Promise((resolve, reject) => {
    fetch({
      url: `markers/${id}`,
      method: 'PUT',
      data: markerData
    })
      .then(({ data }) => {
        commit(types.TOGGLE_LOADING);
        commit(types.UPDATE_MARKER, data["data"]);
        commit(types.SET_MESSAGE, data["message"]);
        resolve(data);
      })
      .catch((e) => {
        commit(types.TOGGLE_LOADING);
        commit(types.SET_ERROR, e.message);
        reject(e);
      });
  });
};

// Supprimer un marker
const deleteMarker = ({ commit }, markerId) => {
  commit(types.TOGGLE_LOADING);
  return new Promise((resolve, reject) => {
    fetch({
      url: `markers/${markerId}`,
      method: 'DELETE'
    })
      .then(({ data }) => {
        commit(types.TOGGLE_LOADING);
        commit(types.DELETE_MARKER, markerId);
        commit(types.SET_MESSAGE, data["message"]);
        resolve(data);
      })
      .catch((e) => {
        commit(types.TOGGLE_LOADING);
        commit(types.SET_ERROR, e.message);
        reject(e);
      });
  });
};

export default {
  getMarkers,
  createMarker,
  updateMarker,
  deleteMarker,
};
